import { numberOptionalSchema, numberRequiredSchema, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { number, object } from 'yup';

const acceptAppointmentSchema = object().shape({

    title: stringRequiredSchema,
    description: stringRequiredSchema,
    appointment_reason:stringRequiredSchema,
    additonal_notes: stringOptionalSchema,
    location: select2RequiredSchema,
    location_notes: stringOptionalSchema,
    location_detail: stringOptionalSchema,
    appointment_type: select2RequiredSchema,
    price: number().when('appointment_type', {
        is: (appointment_type) => appointment_type?.value === "paid",
        then: () => numberRequiredSchema,
        otherwise: () => numberOptionalSchema,
    }),
});

export default acceptAppointmentSchema;